import PropTypes from 'prop-types';
import React, {useMemo} from 'react';
import './AccordionItem.scss';

export const AccordionItem = ({ answer, question, isOpen, onClick }) => {

  const id = useMemo(() => Math.random().toString(36).substring(7), [])

  return (
    <div className={`c-accordion-item ${isOpen && "open"}`}>
      <button
        className="c-accordion-item__question"
        id={`accordion-${id}-label`}
        aria-controls={`accordion-${id}`}
        aria-expanded={isOpen}
        onClick={onClick}>

        <h3>{question}</h3>
        <span className="c-accordion-item__icon" />
      </button>

      <div
        className="c-accordion-item__answer o-wysiwyg"
        id={`accordion-${id}`}
        role="region"
        aria-labelledby={`accordion-${id}-label`}>
        <div className="c-accordion-item__answer-inner" dangerouslySetInnerHTML={{__html: answer}}>
        </div>
      </div>
    </div>
  )
}

AccordionItem.propTypes = {
  answer  : PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  onClick : PropTypes.func.isRequired,
  isOpen  : PropTypes.bool.isRequired
}
